module.exports = __webpack_public_path__ + "img/separador.f3445142.svg";